import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setEditId, selectBundleById } from "src/store/community/bundlesSlice";
import { fetchBundle } from "src/actions/community/bundlesActions";

import PageLayout from "../_partials/PageLayout";
import SummaryShow from "src/componets/SummaryShow";
import Products from "./_partials/_Products";
import Settings from "./_partials/_Settings";
import Tabs from "src/componets/Tabs";
import Edit from "./Edit";
import { ButtonEdit } from "src/componets/Buttons";
import SidebarShow from "../Bundles/_partials/_SidebarShow";

const Show: React.FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const bundle = useAppSelector(state => id ? selectBundleById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchBundle(id));
    }
  }, [id, dispatch]);

  function onClickEdit() {
    if (bundle) {
      dispatch(setEditId(bundle.id));
    }
  }

  return (
    <PageLayout className='v-bundles-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            bundle &&
              <SummaryShow
                title={bundle.name}
                image={bundle.icon_url}
                createdAt={bundle.created_at}
                updatedAt={bundle.updated_at}
                actions={[
                  <ButtonEdit key='button-edit' onClick={onClickEdit} />
                ]}
                className='v-mb-15'
              />
          }

          <Tabs
            paramsKey='tab'
            destroyInactiveTabPane={true}
            items={[
              { label: 'Settings', key: 'settings', children: <Settings bundle={bundle} /> },
              { label: 'Products', key: 'products', children: <Products bundle={bundle} /> }
            ]}
          />
        </div>
      </div>

      <Edit />

      <SidebarShow bundle={bundle} />
    </PageLayout>
  )
}

export default Show;
